module.exports = __webpack_public_path__ + "img/formador-20.2fae278f.png";